import { render, staticRenderFns } from "./permissionGroups.vue?vue&type=template&id=10137f91&scoped=true"
import script from "./permissionGroups.vue?vue&type=script&lang=js"
export * from "./permissionGroups.vue?vue&type=script&lang=js"
import style0 from "./permissionGroups.vue?vue&type=style&index=0&id=10137f91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10137f91",
  null
  
)

export default component.exports